import { type HttpClient } from '@/application/interfaces/http-client';

export type CashbacksCotationPointsResponse = {
  data: Array<{
    availabilityFactor: number;
    loyaltyReward: {
      counterRequirement: {
        amount: number;
        type: string;
      };
      triggerCode: string;
      identifier: string;
      label: string;
      shortLabel: string;
      value: string;
      type: string;
    };
    available: boolean;
  }>;
};

export const getCashbacksCotationPoints =
  (httpClient: HttpClient.Instance) => async () => {
    return httpClient.get<CashbacksCotationPointsResponse>(
      '/api/v3/carts/cashbacks-cotation-points'
    );
  };
